import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  validateUser,
  validatePoliticalInformation,
  validateEconomicInformation,
  validateRelationshipWithMutual,
  validateEmployerInformation,
} from "./validation";
import styles from "./UserForm.module.css";
import IconAnimation from "../../components/iconAnimation/iconAnimation";
import Swal from "sweetalert2";
import { Glossary } from "../../components";
import axios from "axios";
import Loader from "../../components/Loader/loader";

const CreateUser = () => {
  const navigate = useNavigate();
  const [LoaderTrueFalse, setLoaderTrueFalse] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [errors, setErrors] = useState({});
  const [dataAndForm, setDataAndForm] = useState({
    dniCuil: "",
  });

  const [user, setUser] = useState({
    name: "",
    lastName: "",
    documentType: "",
    dni: "",
    civilStatus: "",
    nacionality: "",
    cuil: "",
    dateOfBirth: "",
    placeOfBirth: "",
    street: "",
    numberStreet: "",
    location: "",
    phone: "",
    email: "",
    status: "Alta",
    province: "",
    apartment: "",
    postalCode: "",
    SocioEconomicLevel: "",
    floor: "",
    typeCustomer: "Persona Humana",
  });

  const [PoliticalInformation, setPoliticalInformation] = useState({
    politicallyExposed: "No",
    terrorismVerification: "",
  });

  const [RelationshipWithMutual, setRelationshipWithMutual] = useState({
    relation: "",
    creditDate: "",
    typeOfCredit: "",
    amountOfCredit: "",
    amountOfFees: "",
    installmentAmount: "",
    loanBank: "",
    canal: "",
    affiliate: "",
    credit: "",
  });

  const [EconomicInformation, setEconomicInformation] = useState({
    IncomeOfHumanPerson: 0,
    total_indebtedness_of_the_financial_system: 0,
    total_monthly_commitment_of_the_financial_system: 0,
    current_status_with_BCRA: 0,
  });
  //probar con defaul value en los inputs (hacer lo que tu cerebro dijo)

  const [EmployerInformation, setEmployerInformation] = useState({
    employer: "",
    ActivityBeingCarriedOut: "",
    employerDomicile: "",
    WorkActivity: "",
    activitySeniority: "",
    activitySeniorityUnit: "years",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const keys = name.split(".");
    if (keys.length === 1) {
      setUser((prevUser) => ({ ...prevUser, [name]: value }));
    } else {
      setUser((prevUser) => ({
        ...prevUser,
        [keys[0]]: { ...prevUser[keys[0]], [keys[1]]: value },
      }));
    }
  };
  //Trae los datos de nosis para que se autocomplete el formulario/;
  const handleApiData = async (event, id) => {
    event.preventDefault();
    const endpoint = `${process.env.REACT_APP_DATA_API_FORM}?id=${id}`;
    try {
      const res = await axios.get(endpoint);
      const datanosis = res.data;
      changeValuesInputs(datanosis);
      Swal.fire({
        icon: "success",
        title: "Exito",
        text: "Se Auto completaron los datos del Formulario , por favor verifique y llene el resto",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error al tratar de llenar el Formulario",
      });
    }
  };

  const changeValuesInputs = (datanosis) => {
    if (datanosis !== null) {
      setUser({
        name: datanosis.name,
        lastName: datanosis.lastName,
        documentType: datanosis.documentType,
        dni: datanosis.dni,
        civilStatus: datanosis.civilStatus,
        nacionality: datanosis.nacionality,
        cuil: datanosis.cuil,
        dateOfBirth: datanosis.dateOfBirth,
        placeOfBirth: datanosis.placeOfBirth,
        street: datanosis.street,
        numberStreet: datanosis.numberStreet,
        location: datanosis.location,
        phone: "",
        email: "",
        status: "Alta",
        province: datanosis.province,
        apartment: datanosis.apartment,
        postalCode: datanosis.postalCode,
        SocioEconomicLevel: datanosis.SocioEconomicLevel,
        floor: datanosis.floor,
        typeCustomer: "Persona Humana",
      });

      setEconomicInformation({
        IncomeOfHumanPerson: datanosis.EconomicInformation.IncomeOfHumanPerson,
        total_indebtedness_of_the_financial_system:
          datanosis.EconomicInformation
            .total_indebtedness_of_the_financial_system,
        total_monthly_commitment_of_the_financial_system:
          datanosis.EconomicInformation
            .total_monthly_commitment_of_the_financial_system,
        current_status_with_BCRA:
          datanosis.EconomicInformation.current_status_with_BCRA,
      });

      setEmployerInformation({
        employer: datanosis.EmployerInformation.employer,
        ActivityBeingCarriedOut:
          datanosis.EmployerInformation.ActivityBeingCarriedOut,
        employerDomicile: datanosis.EmployerInformation.employerDomicile,
        WorkActivity: datanosis.EmployerInformation.WorkActivity,
        activitySeniority: datanosis.EmployerInformation.activitySeniority,
        activitySeniorityUnit: "years",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Ingrese un Dni/Cuil o Cuit",
      });
    }
  };

  const handleNext = async (event) => {
    event.preventDefault();
    setLoaderTrueFalse(true);
    setShowButton(false);

    const validationErrorsUser = validateUser(user);
    const validationErrorsEconomic =
      validateEconomicInformation(EconomicInformation);
    const validationErrorsEmployer =
      validateEmployerInformation(EmployerInformation);
    const validationErrorsRelation = validateRelationshipWithMutual(
      RelationshipWithMutual
    );
    const validationErrorsPolitical =
      validatePoliticalInformation(PoliticalInformation);

    const hasValidationErrors =
      Object.keys(validationErrorsUser).length > 0 ||
      Object.keys(validationErrorsEconomic).length > 0 ||
      Object.keys(validationErrorsEmployer).length > 0 ||
      Object.keys(validationErrorsRelation).length > 0 ||
      Object.keys(validationErrorsPolitical).length > 0;

    if (!hasValidationErrors) {
      const formattedUser = {
        ...user,
        PoliticalInformation: {
          ...PoliticalInformation,
        },
        RelationshipWithMutual: {
          ...RelationshipWithMutual,
        },
        EconomicInformation: {
          ...EconomicInformation,
        },
        EmployerInformation: {
          ...EmployerInformation,
        },
      };

      try {
        const res = await axios.post(process.env.REACT_APP_CREATE_USER_API, {
          user: formattedUser,
        });
        if (res.status === 200) {
          //si no hay probblemas da una aviso que se guardaron los datos
          Swal.fire({
            icon: "success",
            title: "Exito",
            text: "La informacion se guardo perfectamente en la base de datos",
          });
          setLoaderTrueFalse(false);
          // una vez que se guardo el usuario se envia nuevamente al inicio
          navigate("/inicio");
        } else {
          setLoaderTrueFalse(false);
          //en caso de problema da un aviso de que hubo un error
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Parece que hubo un error al guardar los datos",
          });
        }
      } catch (error) {
        setLoaderTrueFalse(false);
        // Si hubo un error en la solicitud, lo mostramos
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      }
    } else {
      setLoaderTrueFalse(false);
      setShowButton(true);
      setErrors({
        ...validationErrorsUser,
        ...validationErrorsEconomic,
        ...validationErrorsEmployer,
        ...validationErrorsRelation,
        ...validationErrorsPolitical,
      });
    }
  };

  return (
    <div>
      {LoaderTrueFalse === true ? <Loader /> : null}
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Autocompletado</h2>
        <div className={styles.boxinputsdefinded}>
          <label className={styles.inputLabel3}>
            Dni/Cuil
            <input
              className={styles.inputField}
              type="number"
              name="name"
              value={dataAndForm.dniCuil || ""}
              onChange={(e) =>
                setDataAndForm({
                  ...dataAndForm,
                  dniCuil: e.target.value,
                })
              }
            />
          </label>
          <button
            className={styles.buttonfield2}
            onClick={(e) => handleApiData(e, dataAndForm.dniCuil)}
          >
            Traer Datos
          </button>
        </div>
        <div className={styles.informacionPersonal} id="personal">
          <h2 className={styles.sectionTitle}>Información Personal</h2>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Nombre:
              <input
                className={styles.inputField}
                type="text"
                name="name"
                value={user.name || ""}
                onChange={handleInputChange}
              />
              {errors.name && <p className={styles.errorText}>{errors.name}</p>}
            </label>
            <label className={styles.inputLabel}>
              Apellido:
              <input
                className={styles.inputField}
                type="text"
                name="lastName"
                value={user.lastName || ""}
                onChange={handleInputChange}
              />
              {errors.lastName && (
                <p className={styles.errorText}>{errors.lastName}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Tipo de documento:
              <select
                className={styles.inputField}
                name="documentType"
                value={user.documentType || ""}
                onChange={handleInputChange}
              >
                <option value="">Selecciona una opción</option>
                <option value="DNI">DNI</option>
                <option value="CUIL">CUIL</option>
              </select>
              {errors.documentType && (
                <p className={styles.errorText}>{errors.documentType}</p>
              )}
            </label>
          </div>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Numero de documento:
              <input
                className={styles.inputField}
                type="text"
                name="dni"
                maxLength={8}
                value={user.dni || ""}
                onChange={handleInputChange}
              />
              {errors.dni && <p className={styles.errorText}>{errors.dni}</p>}
            </label>
            <label className={styles.inputLabel}>
              Estado civil:
              <select
                className={styles.inputField}
                name="civilStatus"
                value={user.civilStatus || ""}
                onChange={handleInputChange}
              >
                <option value="">Selecciona una opción</option>
                <option value="Soltero/a">Soltero/a</option>
                <option value="Casado/a">Casado/a</option>
                <option value="Divorciado/a">Divorciado/a</option>
                <option value="Viudo/a">Viudo/a</option>
                <option value="Separado/a legalmente">
                  Separado/a legalmente
                </option>
                <option value="Union libre o concubinato">
                  Union libre o concubinato
                </option>
                <option value="Casado/a civilmente">Casado/a civilmente</option>
                <option value="Pareja de hecho">Pareja de hecho</option>
              </select>
              {errors.civilStatus && (
                <p className={styles.errorText}>{errors.civilStatus}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Nacionalidad:
              <input
                className={styles.inputField}
                type="text"
                name="nacionality"
                value={user.nacionality || ""}
                onChange={handleInputChange}
              />
              {errors.nacionality && (
                <p className={styles.errorText}>{errors.nacionality}</p>
              )}
            </label>
          </div>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Cuil:
              <input
                className={styles.inputField}
                type="text"
                name="cuil"
                maxLength={11}
                value={user.cuil || ""}
                onChange={handleInputChange}
              />
              {errors.cuil && <p className={styles.errorText}>{errors.cuil}</p>}
            </label>
            <label className={styles.inputLabel}>
              Fecha de nacimiento:
              <input
                className={styles.inputField}
                type="date"
                name="dateOfBirth"
                value={user.dateOfBirth || ""}
                onChange={handleInputChange}
              />
              {errors.dateOfBirth && (
                <p className={styles.errorText}>{errors.dateOfBirth}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Lugar de nacimiento:
              <input
                className={styles.inputField}
                type="text"
                name="placeOfBirth"
                value={user.placeOfBirth || ""}
                onChange={handleInputChange}
              />
              {errors.placeOfBirth && (
                <p className={styles.errorText}>{errors.placeOfBirth}</p>
              )}
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Teléfono:
              <input
                className={styles.inputField}
                type="tel"
                name="phone"
                value={user.phone || ""}
                onChange={handleInputChange}
              />
            </label>
            <label className={styles.inputLabel}>
              Correo electrónico:
              <input
                className={styles.inputField}
                type="email"
                name="email"
                value={user.email || ""}
                onChange={handleInputChange}
              />
            </label>
            <label className={styles.inputLabel}>
              Nivel socioeconómico:
              <select
                className={styles.inputField}
                name="SocioEconomicLevel"
                value={user.SocioEconomicLevel || ""}
                onChange={(e) =>
                  setUser({
                    ...user,
                    SocioEconomicLevel: e.target.value,
                  })
                }
              >
                <option value="">Selecciona una opción</option>
                <option value="D2">D2</option>
                <option value="D1">D1</option>
                <option value="C3">C3</option>
                <option value="C2">C2</option>
                <option value="C1">C1</option>
                <option value="B">B</option>
                <option value="A">A</option>
              </select>
              {errors.SocioEconomicLevel && (
                <p className={styles.errorText}>{errors.SocioEconomicLevel}</p>
              )}
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Calle:
              <input
                className={styles.inputField}
                type="text"
                name="street"
                value={user.street || ""}
                onChange={handleInputChange}
              />
              {errors.street && (
                <p className={styles.errorText}>{errors.street}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Numero:
              <input
                className={styles.inputField}
                type="number"
                name="numberStreet"
                value={user.numberStreet || ""}
                onChange={handleInputChange}
              />
              {errors.numberStreet && (
                <p className={styles.errorText}>{errors.numberStreet}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Codigo postal:
              <input
                className={styles.inputField}
                type="text"
                name="postalCode"
                value={user.postalCode || ""}
                onChange={handleInputChange}
              />
              {errors.postalCode && (
                <p className={styles.errorText}>{errors.postalCode}</p>
              )}
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Departamento:
              <input
                className={styles.inputField}
                type="text"
                name="apartment"
                value={user.apartment || ""}
                onChange={handleInputChange}
              />
              {errors.apartment && (
                <p className={styles.errorText}>{errors.apartment}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Piso:
              <input
                className={styles.inputField}
                type="text"
                name="piso"
                value={user.floor || ""}
                onChange={(e) => setUser({ ...user, floor: e.target.value })}
              />
              {errors.floor && (
                <p className={styles.errorText}>{errors.floor}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Localidad:
              <input
                className={styles.inputField}
                type="location"
                name="location"
                value={user.location || ""}
                onChange={handleInputChange}
              />
              {errors.location && (
                <p className={styles.errorText}>{errors.location}</p>
              )}
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Provincia:
              <select
                className={styles.inputField}
                name="province"
                value={user.province || ""}
                onChange={handleInputChange}
              >
                <option value="">Selecciona una opción</option>
                <option value="Provincia de Buenos Aires">
                  Provincia de Buenos Aires
                </option>
                <option value="Distinto a Provincia de Buenos Aires">
                  Distinto a Provincia de Buenos Aires
                </option>
              </select>
              {errors.province && (
                <p className={styles.errorText}>{errors.province}</p>
              )}
            </label>
          </div>
        </div>

        <div className={styles.informacionEconomica} id="economica">
          <div className={styles.sectionTitle2}>
            <h2 className={styles.sectionTitleH2}>Información Económica</h2>
            <IconAnimation className={styles.iconAlert} />
          </div>
          <div className={styles.boxinfo3}>
            <label className={styles.inputLabel2}>
              Monto transaccional anual:
              <input
                className={styles.inputField}
                type="number"
                name="IncomeOfHumanPerson"
                value={EconomicInformation.IncomeOfHumanPerson || ""}
                onChange={(e) =>
                  setEconomicInformation({
                    ...EconomicInformation,
                    IncomeOfHumanPerson: e.target.value,
                  })
                }
              />
              {errors.IncomeOfHumanPerson && (
                <p className={styles.errorText}>{errors.IncomeOfHumanPerson}</p>
              )}
            </label>
            <label className={styles.inputLabel2}>
              Total de endeudamiento del sistema financiero:
              <input
                className={styles.inputField}
                type="number"
                name="total_indebtedness_of_the_financial_system"
                value={
                  EconomicInformation.total_indebtedness_of_the_financial_system ||
                  ""
                }
                onChange={(e) =>
                  setEconomicInformation({
                    ...EconomicInformation,
                    total_indebtedness_of_the_financial_system: e.target.value,
                  })
                }
              />
              {errors.total_indebtedness_of_the_financial_system && (
                <p className={styles.errorText}>
                  {errors.total_indebtedness_of_the_financial_system}
                </p>
              )}
            </label>
          </div>
          <div className={styles.boxinfo3}>
            <label className={styles.inputLabel2}>
              Total de compromiso mensual sistema financiero:
              <input
                className={styles.inputField}
                type="number"
                name="total_monthly_commitment_of_the_financial_system"
                value={
                  EconomicInformation.total_monthly_commitment_of_the_financial_system ||
                  ""
                }
                onChange={(e) =>
                  setEconomicInformation({
                    ...EconomicInformation,
                    total_monthly_commitment_of_the_financial_system:
                      e.target.value,
                  })
                }
              />
              {errors.total_monthly_commitment_of_the_financial_system && (
                <p className={styles.errorText}>
                  {errors.total_monthly_commitment_of_the_financial_system}
                </p>
              )}
            </label>
            <label className={styles.inputLabel2}>
              Situación vigente ante BCRA:
              <input
                className={styles.inputField}
                type="text"
                name="current_status_with_BCRA"
                value={EconomicInformation.current_status_with_BCRA || ""}
                onChange={(e) =>
                  setEconomicInformation({
                    ...EconomicInformation,
                    current_status_with_BCRA: e.target.value,
                  })
                }
              />
              {errors.current_status_with_BCRA && (
                <p className={styles.errorText}>
                  {errors.current_status_with_BCRA}
                </p>
              )}
            </label>
          </div>
        </div>
        <div className={styles.informacionEmpleador} id="empleador">
          <div className={styles.sectionTitle2}>
            <h2 className={styles.sectionTitleH2}>Información Empleador</h2>
            <IconAnimation />
          </div>
          <div className={styles.boxinfo3}>
            <label className={styles.inputLabel2}>
              Empleador:
              <input
                className={styles.inputField}
                type="text"
                name="employer"
                value={EmployerInformation.employer || ""}
                onChange={(e) =>
                  setEmployerInformation({
                    ...EmployerInformation,
                    employer: e.target.value,
                  })
                }
              />
              {errors.employer && (
                <p className={styles.errorText}>{errors.employer}</p>
              )}
            </label>
            <label className={styles.inputLabel2}>
              Domicilio empleador:
              <input
                className={styles.inputField}
                type="text"
                name="employerDomicile"
                value={EmployerInformation.employerDomicile || ""}
                onChange={(e) =>
                  setEmployerInformation({
                    ...EmployerInformation,
                    employerDomicile: e.target.value,
                  })
                }
              />
              {errors.employerDomicile && (
                <p className={styles.errorText}>{errors.employerDomicile}</p>
              )}
            </label>
          </div>
          <div className={styles.boxinfo3}>
            <div className={styles.boxinfo3}>
              <label className={styles.inputLabel2}>
                Antigüedad en la actividad:
                <input
                  className={styles.inputField}
                  type="text"
                  name="activitySeniority"
                  value={EmployerInformation.activitySeniority || ""}
                  onChange={(e) =>
                    setEmployerInformation({
                      ...EmployerInformation,
                      activitySeniority: e.target.value,
                    })
                  }
                />
                {errors.WorkActivity && (
                  <p className={styles.errorText}>{errors.WorkActivity}</p>
                )}
              </label>
            </div>
            <label className={styles.inputLabel2}>
              Actividad laboral:
              <input
                className={styles.inputField}
                type="text"
                name="WorkActivity"
                value={EmployerInformation.WorkActivity || ""}
                onChange={(e) =>
                  setEmployerInformation({
                    ...EmployerInformation,
                    WorkActivity: e.target.value,
                  })
                }
              />
              {errors.WorkActivity && (
                <p className={styles.errorText}>{errors.WorkActivity}</p>
              )}
            </label>
          </div>
          <div className={styles.boxinfo3}>
            <label className={styles.inputLabel2}>
              Actividad que desarrolla:
              <textarea
                className={styles.inputField}
                name="ActivityBeingCarriedOut"
                id={styles.idtextareacreatuser}
                rows={6}
                cols={100}
                value={EmployerInformation.ActivityBeingCarriedOut || ""}
                onChange={(e) =>
                  setEmployerInformation({
                    ...EmployerInformation,
                    ActivityBeingCarriedOut: e.target.value,
                  })
                }
              />
              {errors.ActivityBeingCarriedOut && (
                <p className={styles.errorText}>
                  {errors.ActivityBeingCarriedOut}
                </p>
              )}
            </label>
          </div>
        </div>

        <div className={styles.informacionRelacion} id="relacion">
          <div className={styles.sectionTitle2}>
            <h2 className={styles.sectionTitleH2}>Relación con la Mutual</h2>
            <IconAnimation />
          </div>
          <div className={styles.boxinfo2}>
            <div className={styles.nad}>
              <label className={styles.inputLabel2}>
                Tipo de relación:
                <select
                  className={styles.inputField}
                  name="relation"
                  value={RelationshipWithMutual.relation || ""}
                  onChange={(e) =>
                    setRelationshipWithMutual({
                      ...RelationshipWithMutual,
                      relation: e.target.value,
                    })
                  }
                >
                  <option value="">Selecciona una opción</option>
                  <option value="Socio">Socio</option>
                  <option value="Proveedor">Proveedor</option>
                  <option value="Fondista">Fondista</option>
                </select>
                {errors.relation && (
                  <p className={styles.errorText}>{errors.relation}</p>
                )}
              </label>
              <label className={styles.inputLabel2}>
                Canal:
                <select
                  className={styles.inputField}
                  name="canal"
                  value={RelationshipWithMutual.canal || ""}
                  onChange={(e) =>
                    setRelationshipWithMutual({
                      ...RelationshipWithMutual,
                      canal: e.target.value,
                    })
                  }
                >
                  <option value="">Selecciona una opción</option>
                  <option value="Físico">Físico</option>
                  <option value="Digital">Digital</option>
                </select>
                {errors.canal && (
                  <p className={styles.errorText}>{errors.canal}</p>
                )}
              </label>
            </div>
            {RelationshipWithMutual.relation === "Socio" && (
              <div className={styles.boxinfo2}>
                <div className={styles.nad}>
                  <label className={styles.inputLabel}>
                    Fecha de crédito:
                    <input
                      className={styles.inputField}
                      type="date"
                      name="creditDate"
                      value={RelationshipWithMutual.creditDate || ""}
                      onChange={(e) =>
                        setRelationshipWithMutual({
                          ...RelationshipWithMutual,
                          creditDate: e.target.value,
                        })
                      }
                    />
                    {errors.creditDate && (
                      <p className={styles.errorText}>{errors.creditDate}</p>
                    )}
                  </label>
                  <label className={styles.inputLabel}>
                    Tipo de crédito:
                    <select
                      className={styles.inputField}
                      name="typeOfCredit"
                      value={"Crédito de consumo"}
                      onChange={(e) =>
                        setRelationshipWithMutual({
                          ...RelationshipWithMutual,
                          typeOfCredit: e.target.value,
                        })
                      }
                    >
                      <option value="Crédito de consumo">
                        Crédito de consumo
                      </option>
                    </select>
                    {errors.typeOfCredit && (
                      <p className={styles.errorText}>{errors.typeOfCredit}</p>
                    )}
                  </label>
                </div>
                <div className={styles.nad}>
                  <label className={styles.inputLabel}>
                    Monto de crédito:
                    <input
                      className={styles.inputField}
                      type="number"
                      name="amountOfCredit"
                      value={RelationshipWithMutual.amountOfCredit || ""}
                      onChange={(e) =>
                        setRelationshipWithMutual({
                          ...RelationshipWithMutual,
                          amountOfCredit: e.target.value,
                        })
                      }
                    />
                    {errors.amountOfCredit && (
                      <p className={styles.errorText}>
                        {errors.amountOfCredit}
                      </p>
                    )}
                  </label>
                  <label className={styles.inputLabel}>
                    Cantidad de cuotas:
                    <input
                      className={styles.inputField}
                      type="number"
                      name="amountOfFees"
                      value={RelationshipWithMutual.amountOfFees || ""}
                      onChange={(e) =>
                        setRelationshipWithMutual({
                          ...RelationshipWithMutual,
                          amountOfFees: e.target.value,
                        })
                      }
                    />
                    {errors.amountOfFees && (
                      <p className={styles.errorText}>{errors.amountOfFees}</p>
                    )}
                  </label>

                  <label className={styles.inputLabel}>
                    Monto de la cuota:
                    <input
                      className={styles.inputField}
                      type="number"
                      name="installmentAmount"
                      value={RelationshipWithMutual.installmentAmount || ""}
                      onChange={(e) =>
                        setRelationshipWithMutual({
                          ...RelationshipWithMutual,
                          installmentAmount: e.target.value,
                        })
                      }
                    />
                    {errors.installmentAmount && (
                      <p className={styles.errorText}>
                        {errors.installmentAmount}
                      </p>
                    )}
                  </label>
                  <label className={styles.inputLabel}>
                    Nombre de prestamista:
                    <input
                      className={styles.inputField}
                      type="text"
                      name="loanBank"
                      value={RelationshipWithMutual.loanBank || ""}
                      onChange={(e) =>
                        setRelationshipWithMutual({
                          ...RelationshipWithMutual,
                          loanBank: e.target.value,
                        })
                      }
                    />
                    {errors.loanBank && (
                      <p className={styles.errorText}>{errors.loanBank}</p>
                    )}
                  </label>
                  <label className={styles.inputLabel}>
                    Afiliado:
                    <input
                      className={styles.inputField}
                      type="text"
                      name="affiliate"
                      value={RelationshipWithMutual.affiliate || ""}
                      onChange={(e) =>
                        setRelationshipWithMutual({
                          ...RelationshipWithMutual,
                          affiliate: e.target.value,
                        })
                      }
                    />
                    {errors.affiliate && (
                      <p className={styles.errorText}>{errors.affiliate}</p>
                    )}
                  </label>
                  <label className={styles.inputLabel}>
                    Crédito:
                    <input
                      className={styles.inputField}
                      type="text"
                      name="credit"
                      value={RelationshipWithMutual.credit || ""}
                      onChange={(e) =>
                        setRelationshipWithMutual({
                          ...RelationshipWithMutual,
                          credit: e.target.value,
                        })
                      }
                    />
                    {errors.credit && (
                      <p className={styles.errorText}>{errors.credit}</p>
                    )}
                  </label>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={styles.informacionPolitica} id="politica">
          <div className={styles.sectionTitle2}>
            <h2 className={styles.sectionTitleH2}>
              Información política y verificación de terrorismo
            </h2>
            <IconAnimation />
          </div>
          <div className={styles.boxinfo3}>
            <label className={styles.inputLabel2}>
              Es políticamente expuesto:
              <select
                className={styles.inputField}
                name="politicallyExposed"
                value={"No"}
                onChange={(e) =>
                  setPoliticalInformation({
                    ...PoliticalInformation,
                    politicallyExposed: e.target.value,
                  })
                }
              >
                <option value="No">No</option>
                <option value="Si">Si</option>
              </select>
              {errors.politicallyExposed && (
                <p className={styles.errorText}>{errors.politicallyExposed}</p>
              )}
            </label>

            <label className={styles.inputLabel2}>
              Verificación de terrorismo (DNI):
              <input
                className={styles.inputField}
                type="number"
                name="terrorismVerification"
                value={PoliticalInformation.terrorismVerification || ""}
                onChange={(e) =>
                  setPoliticalInformation({
                    ...PoliticalInformation,
                    terrorismVerification: e.target.value,
                  })
                }
              />
            </label>
          </div>
        </div>
        <Glossary />
        {showButton && (
          <button className={styles.buttonsavematriz} onClick={handleNext}>
            Crear
          </button>
        )}
      </div>
    </div>
  );
};

export default CreateUser;
